import React, { useState, useEffect } from "react";
import IconButton from "components/common/iconButton";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import { Link, useNavigate } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";
import SubtleBadge from "components/common/subtleBadge";
import AdvanceTable from "components/common/advance-table/advanceTable";
import AdvanceTableSearchBox from "components/common/advance-table/advanceTableSearchBox";
import AdvanceTablePagination from "components/common/advance-table/advanceTablePagination";
import AdvanceTableFooter from 'components/common/advance-table/advanceTableFooter';
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/advanceTableProvider";
import corner4 from "assets/img/illustrations/corner-4.png";
import Background from "components/common/background";
import paths from "routes/paths";
import {getInitialPageSize } from "../../../assets/js/common";

const Inventries = () => {
  const inventoryData = [
    {
      Naam: 'Material A',
      HuidigeVoorraad: 120,
      InGebruik: 45,
      ToegevoegdDoor: 'Lucas Jansen',
      BijgewerktDoor: 'Emma van Dijk',
      ToegevoegdeDatum: '11-03-2024'
    },
    {
      Naam: 'Material B',
      HuidigeVoorraad: 80,
      InGebruik: 30,
      ToegevoegdDoor: 'Sophie Brouwer',
      BijgewerktDoor: 'Milan de Boer',
      ToegevoegdeDatum: '27-01-2024'
    },
    {
      Naam: 'Material C',
      HuidigeVoorraad: 200,
      InGebruik: 65,
      ToegevoegdDoor: 'Noah Vermeer',
      BijgewerktDoor: 'Lotte van Dam',
      ToegevoegdeDatum: '05-04-2024'
    }
  ];

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(inventoryData);
  // const handleViewDetails = (templateId) => {
  //   navigate(`${paths.templateDetails.replace(":templateId", templateId)}`);
  // };

  const columns = [
    {
      accessorKey: "Naam",
      header: t("name"),
      cell: ({ row: { original } }) => <span>{original.Naam}</span>
    },
    {
      accessorKey: "HuidigeVoorraad",
      header: t("currentStock"),
      cell: ({ row: { original } }) => <span>{original.HuidigeVoorraad}</span>
    },
    {
      accessorKey: "InGebruik",
      header: t("inUse"),
      cell: ({ row: { original } }) => <span>{original.InGebruik}</span>
    },
    {
      accessorKey: "ToegevoegdDoor",
      header: t("addedBy"),
      cell: ({ row: { original } }) => <span>{original.ToegevoegdDoor}</span>
    },
    {
      accessorKey: "BijgewerktDoor",
      header: t("updatedBy"),
      cell: ({ row: { original } }) => <span>{original.BijgewerktDoor}</span>
    },
    {
      accessorKey: "ToegevoegdeDatum",
      header: t("addedDate"),
      cell: ({ row: { original } }) => <span>{original.ToegevoegdeDatum}</span>
    }
  ];

  const table = useAdvanceTable({
    data,
    columns,
    selection: false,
    sortable: true,
    pagination: true,
    perPage: getInitialPageSize('inventriesTable')
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <Row className="g-3 mb-3">
          <Col lg={12} xxl={12}>
            <Card className="mb-3 h-100">
              <Background image={corner4} className="bg-card" />
              <Card.Body className="position-relative pe-3 pb-2">
                <Row className="flex-between-center">
                  <Col md>
                    <h5 className="mb-2 mb-md-0">{t("inventory")}</h5>
                  </Col>
                  <Col xs="auto">
                    <IconButton
                      // as={Link}
                      // to={paths.addInventory}
                      variant="primary"
                      size="sm"
                      icon="plus"
                      transform="shrink-3"
                    >
                      <span className="ms-1">{t("addInventory")}</span>
                    </IconButton>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Card className="mb-3">
          <Card.Header>
            {/* <Row className="flex-between-center">
                <Col xs={8} sm="auto" className="ms-auto text-end ps-0">
                  <AdvanceTableSearchBox setGlobalFilter={setGlobalFilter} />
                </Col>
              </Row> */}
          </Card.Header>
          <Card.Body className="p-0">

            <>
              <AdvanceTable
                rows={table.rows} // ✅ This is required
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
                tableProps={{
                  bordered: true,
                  striped: true,
                  size: "sm",
                  className: "mb-0 overflow-hidden data-font-size table-hover",
                }}
                getRowProps={(row) => ({
                  style: { cursor: "pointer" }
                })}
              />
              {inventoryData.length === 0 ? (
                <div className="text-center pt-4">
                  {t("noDataAvailableText")}
                </div>
              ) : null}
            </>
          </Card.Body>
          <Card.Footer>
            {/* <AdvanceTablePagination /> */}
            <AdvanceTableFooter
              rowInfo
              navButtons
              rowsPerPageSelection
              tableKey="inventriesTable"
            />
          </Card.Footer>
        </Card>
      </AdvanceTableProvider>
    </>
  );
}
export default Inventries;